export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/constant.js
// module id = 384
// module chunks = 0 1 2 3 4